import api from "./api";

export const getAllNetworkDevices = async (schemaName = null) => {
  try {
    const response = await api.get("/network-devices/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching network devices:", error);
    throw error;
  }
};

export const getNetworkDeviceById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/network-devices/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching network device:", error);
    throw error;
  }
};

export const createNetworkDevice = async (data, schemaName = null) => {
  try {
    const response = await api.post("/network-devices/", data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating network device:", error);
    throw error;
  }
};

export const updateNetworkDevice = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/network-devices/${id}/`, data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error updating network device:", error);
    throw error;
  }
};

export const deleteNetworkDevice = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/network-devices/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting network device:", error);
    throw error;
  }
};

export const getTechTypes = async (schemaName = null) => {
  try {
    const response = await api.get("/network-devices/tech-types/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tech types:", error);
    throw error;
  }
};

export const getDeviceTypes = async (schemaName = null) => {
  try {
    const response = await api.get("/network-devices/device-types/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching device types:", error);
    throw error;
  }
};
